import { handleActions } from 'redux-actions';
import { postData, deleteData } from '../utils/parkingRequest';

const initialState = {
  email: null,
  username: null,
  token: null,
  loggedInPark: false,
  error: null,
};

const PARKING_LOGIN_ATTEMPT = 'PARKING_LOGIN_ATTEMPT';
const PARKING_LOGIN_SUCCESS = 'PARKING_LOGIN_SUCCESS';
const PARKING_LOGIN_FAILURE = 'PARKING_LOGIN_FAILURE';
const PARKING_LOGOUT = 'PARKING_LOGOUT';
const PARKING_LOGOUT_FAILURE = 'PARKING_LOGOUT_FAILURE';

/** ******************* ACTIONS ******************** */

const parkingLoginAttempt = () => ({
  type: [PARKING_LOGIN_ATTEMPT],
});

const parkingLoginSuccess = ({ authentication_token, email, username }) => ({
  type: [PARKING_LOGIN_SUCCESS],
  token: authentication_token,
  email,
  username,
});

const parkingLoginFailure = error => ({
  type: [PARKING_LOGIN_FAILURE],
  error,
});

const parkingLogoutSuccess = () => ({ type: [PARKING_LOGOUT] });

const parkingLogoutFailure = error => ({
  type: [PARKING_LOGOUT_FAILURE],
  error,
});

export const tryParkingLogin = (body, history) => dispatch => {
  dispatch(parkingLoginAttempt());

  return postData('parking_attendants/signin', body)
    .then(response => dispatch(parkingLoginSuccess(response)))
    .then(() => history.push('/parking'))
    .catch(error => dispatch(parkingLoginFailure()));
};

export const tryParkingLogout = () => dispatch =>
  deleteData('parking_attendants/signout')
    .then(() => dispatch(parkingLogoutSuccess()))
    .then(() => localStorage.clear())
    .catch(() => dispatch(parkingLogoutFailure()));

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [PARKING_LOGIN_ATTEMPT]: state => ({
      ...state,
      error: null,
    }),

    [PARKING_LOGIN_SUCCESS]: (state, { token, email, username }) => ({
      ...state,
      email,
      username,
      token,
      loggedInPark: true,
      error: null,
    }),

    [PARKING_LOGOUT]: state => ({
      ...state,
      email: null,
      username: null,
      token: null,
      loggedInPark: false,
      error: null,
    }),

    [PARKING_LOGIN_FAILURE]: (state, { error }) => ({
      ...state,
      error,
    }),

    [PARKING_LOGOUT_FAILURE]: (state, { error }) => ({
      ...state,
      error,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/parkingAuth.js